import { connect } from 'react-redux';
import { IHeaderEvents } from '../components/types';
import { Header } from '../components/Header';
import { HeaderEvents } from './events';

const mapDispatchToProps = (
  dispatch: any
): IHeaderEvents => ({
    onClickLogo: () => dispatch(HeaderEvents.onClickLogo()),
  }
);

export const HeaderHOC = connect(
  null,
  mapDispatchToProps
)(Header);

HeaderHOC.displayName = 'HeaderHOC';
